import React from 'react'
import Preview from './preview'
import Impressions from './impressions'
import Details from './details'

export default function LandingPagesOverview(props) {
    return (
        <div className='row'>
            <div className='col-xs-12 col-sm-6 col-md-8 col-lg-9'>
                <Preview landingPage={props.landingPage} url={props.url} />
            </div>
            <div className='col-xs-12 col-sm-6 col-md-4 col-lg-3'>
                <Impressions landingPage={props.landingPage} />
                <Details landingPage={props.landingPage} url={props.url} />
            </div>
        </div>
    )
}
